
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CheckCircle, Home } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const ThankYouPage = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-grow flex items-center justify-center bg-gray-50 pt-20 pb-20">
                <div className="container-custom">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5 }}
                        className="max-w-2xl mx-auto text-center bg-white p-10 rounded-3xl shadow-xl border border-gray-100"
                    >
                        <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
                            className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6"
                        >
                            <CheckCircle className="w-12 h-12 text-green-600" />
                        </motion.div>

                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-heading">
                            Thank You!
                        </h1>

                        <p className="text-xl text-gray-600 mb-8">
                            Your submission has been received. We will get back to you shortly.
                        </p>

                        <Link
                            to="/"
                            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-xl font-semibold transition-all duration-300 shadow-lg hover:shadow-xl"
                        >
                            <Home className="w-5 h-5" />
                            Back to Home
                        </Link>
                    </motion.div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default ThankYouPage;
